export const mergeObjects = (intialObj,userObj) => {

    return {
        ...intialObj,
        ...userObj
    }
}